import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useConfirmStore } from "@/stores/confirm";

// ─── Imperative API (preserved – callers do not change) ────────────────────

interface DeleteConfirmProps {
  onConfirm: () => void;
  title?: string;
  description?: string;
}

export function showDeleteConfirm({
  onConfirm,
  title = "Silme Onayı",
  description = "Bu öğeyi silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
}: DeleteConfirmProps) {
  useConfirmStore.getState().openConfirm({ title, description, onConfirm });
}

// ─── Host component – mount once in App.tsx ────────────────────────────────

export function ConfirmHost() {
  const { open, title, description, onConfirm, closeConfirm } = useConfirmStore();

  const handleConfirm = () => {
    onConfirm?.();
    closeConfirm();
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) closeConfirm();
      }}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={closeConfirm}>
            İptal
          </Button>
          <Button variant="destructive" onClick={handleConfirm}>
            Sil
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
